export default "__VITE_ASSET__DvIy0MI2__"